import * as React from 'react'

const SvgChartBarIcon = (props) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.9167 3.33333L3.58333 10.6667M4.91667 6V3.33333M3.58333 4.66667H6.25M8.25 9.33333H10.9167M4.45 13H10.05C11.1701 13 11.7302 13 12.158 12.782C12.5343 12.5903 12.8403 12.2843 13.032 11.908C13.25 11.4802 13.25 10.9201 13.25 9.8V4.2C13.25 3.0799 13.25 2.51984 13.032 2.09202C12.8403 1.71569 12.5343 1.40973 12.158 1.21799C11.7302 1 11.1701 1 10.05 1H4.45C3.3299 1 2.76984 1 2.34202 1.21799C1.96569 1.40973 1.65973 1.71569 1.46799 2.09202C1.25 2.51984 1.25 3.0799 1.25 4.2V9.8C1.25 10.9201 1.25 11.4802 1.46799 11.908C1.65973 12.2843 1.96569 12.5903 2.34202 12.782C2.76984 13 3.3299 13 4.45 13Z"
      stroke="white"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgChartBarIcon
